import bridge from '@vkontakte/vk-bridge';
import type { StorageAdapter } from './StorageAdapter';
import type { StorageRecordKey } from './storageKeys';
import { toStorageStringKey } from './storageKeys';

/**
 * Хранилище VK Mini App. Ключи совпадают с {@link LocalStorageAdapter} (namespaced string).
 */
export class VkStorageAdapter implements StorageAdapter {
  async get(recordKey: StorageRecordKey): Promise<string | null> {
    const key = toStorageStringKey(recordKey);
    const res = await bridge.send('VKWebAppStorageGet', { keys: [key] });
    const row = res.keys.find((k) => k.key === key);
    const value = row?.value;
    return value === undefined || value === '' ? null : value;
  }

  async set(recordKey: StorageRecordKey, value: string): Promise<void> {
    const key = toStorageStringKey(recordKey);
    await bridge.send('VKWebAppStorageSet', { key, value });
  }

  async remove(recordKey: StorageRecordKey): Promise<void> {
    await this.set(recordKey, '');
  }
}
